const useShortcuts = async () => {
  const { data } = await window.axios.get<IPChat.Shortcut[]>(
    route('system.resources.getShortcuts')
  )
  return data
}

export default useShortcuts
